// extracted by mini-css-extract-plugin
export var reviews = "style-module--reviews--e510e";
export var reviews__block = "style-module--reviews__block--c1d5e";
export var reviews__blocks = "style-module--reviews__blocks--befda";